import "core-js/modules/es.array.push.js";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import AMapLoader from "@amap/amap-jsapi-loader";
import { useMainStore } from "../../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive, ref, computed, watch } from "vue";
import { isPhoneNumber, actualCost } from "../../util/index";
import { invoiceTypeList, settleTypeMap, depositTypeMap, followCarList, followCarTypeList, freightTypeList, carNumMap } from "../../util/type";
import moment from "moment";
import { ElMessage } from "element-plus";
export default {
  name: "ordinary",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      times: [],
      resultVisible: false,
      packageList: [],
      carLen: [],
      carType: [],
      carDischarge: [],
      temperatureList: {},
      freightUnitTypeList: [{
        text: "吨",
        type: 0
      }, {
        text: "方",
        type: 1
      }, {
        text: "辆",
        type: 2
      }],
      invoiceTitleList: []
    });
    const formData = reactive({
      amount: "",
      //货运费用(单价)
      beginTime: "",
      //装车开始时间
      carLengthList: [],
      //车长
      carModelList: [],
      //车型
      carDisplacementList: [],
      //排放
      carNum: "0",
      //需求车辆 0->一辆车 1->多辆车
      endTime: "",
      //装车结束时间
      goodsName: "",
      //货物名称
      goodsPicUrlList: [],
      //货物图片URL
      hasInvoice: 1,
      //是否开票 0->否 1->是
      invoiceId: "",
      //发票抬头ID
      packageName: "",
      //包装方式
      remark: "",
      //备注
      square: "",
      //货源方值
      temperatureName: "",
      //温度需求
      tonnage: "",
      //货源吨值
      unitType: 0,
      //结算单位 0->吨 1->方 2->辆
      loading: [{}],
      unloading: [{}]
    });
    const formRef = ref();
    const rules = {
      loading: [{
        validator: (rule, value, callback) => {
          if (!formData.loading.length || !Object.keys(formData.loading[0]).length) {
            callback(new Error("请选择装货地"));
          } else {
            callback();
          }
        }
      }],
      unloading: [{
        validator: (rule, value, callback) => {
          if (!formData.unloading.length || !Object.keys(formData.unloading[0]).length) {
            callback(new Error("请选择卸货地"));
          } else {
            callback();
          }
        }
      }],
      amount: [{
        required: true,
        validator: (rule, value, callback) => {
          if (/^\d+(\.\d{1,2})?$/.test(value) && value != 0) {
            callback();
          } else {
            callback(new Error("请输入有效金额不超出2位小数"));
          }
        }
      }],
      beginTime: [{
        required: true,
        message: "请选择装货时间",
        trigger: "change"
      }],
      invoiceId: [{
        required: true,
        message: "请选择受票方",
        trigger: "change"
      }],
      carLengthList: [{
        required: true,
        message: "请选择车长",
        trigger: "change"
      }, {
        validator: (rule, value, callback) => {
          if (!value.length) {
            callback(new Error("请选择车长"));
          } else {
            callback();
          }
        }
      }],
      carModelList: [{
        required: true,
        message: "请选择车型",
        trigger: "change"
      }, {
        validator: (rule, value, callback) => {
          if (!value.length) {
            callback(new Error("请选择车型"));
          } else {
            callback();
          }
        }
      }],
      carDisplacementList: [{
        required: true,
        message: "请选择车辆排放标准",
        trigger: "change"
      }, {
        validator: (rule, value, callback) => {
          if (!value.length) {
            callback(new Error("请选择车辆排放标准"));
          } else {
            callback();
          }
        }
      }],
      carNum: [{
        required: true,
        message: "请选择需要车辆",
        trigger: "change"
      }],
      goodsName: [{
        required: true,
        message: "请选择货物名称",
        trigger: "change"
      }],
      // goodsPicUrlList: [
      //   {
      //     required: true,
      //     message: "请上传货物图片",
      //     trigger: "change",
      //   },
      //   {
      //     validator: (rule, value, callback) => {
      //       if (!value.length) {
      //         callback(new Error("请上传货物图片"));
      //       } else {
      //         callback();
      //       }
      //     },
      //   },
      // ],
      packageName: [{
        required: true,
        message: "请选择包装方式",
        trigger: "change"
      }],
      tonnage: [{
        required: true,
        message: "请输入货源吨值",
        trigger: "blur"
      }, {
        validator: (rule, value, callback) => {
          if (value && value > 60) {
            ElMessage.warning("由于您的货物数量较多，需要车辆已自动变更为多辆车");
            formData.carNum = "1";
          }
          callback();
        }
      }],
      square: [{
        validator: (rule, value, callback) => {
          if (value && value > 80) {
            ElMessage.warning("由于您的货物数量较多，需要车辆已自动变更为多辆车");
            formData.carNum = "1";
          }
          callback();
        }
      }],
      temperatureName: [{
        required: true,
        message: "请选择温度需求",
        trigger: "change"
      }]
    };
    onMounted(async () => {
      await init();
      route.query.demandId && (await selectDemandDetail());
    });
    const init = () => {
      selectGoodsByGoodsName();
      queryPackageTypeName();
      selectTemperature();
      getSelectCarLength();
      getSelectCar();
      getSelectNewDischarge();
      queryInvoiceTitle();
    };

    //根据发货需求ID查询发货需求信息
    const selectDemandDetail = async () => {
      const res = await globalProperties.$api.selectDemandDetail(route.query.demandId);
      await selectGoodsByGoodsName(res.goodsName);
      formData.loading = res.addressList.filter(item => item.addressType == 1);
      formData.unloading = res.addressList.filter(item => item.addressType == 2);
      formData.goodsName = res.goodsName;
      formData.carNum = res.carNum.toString();
      formData.invoiceId = res.invoiceId;
      formData.hasInvoice = res.hasInvoice;
      formData.packageName = res.packageName;
      formData.tonnage = res.tonnage / 100;
      formData.square = res.square / 100;
      formData.temperatureName = res.temperatureName;
      formData.goodsName = res.goodsName;
      formData.beginTime = moment(res.beginTime).format("YYYY-MM-DD HH:mm:ss");
      formData.endTime = moment(res.endTime || res.beginTime).format("YYYY-MM-DD HH:mm:ss");
      data.times = [formData.beginTime, formData.endTime];
      formData.amount = res.amount / 100;
      formData.goodsPicUrlList = (res.goodsPicUrlList || []).map(item => item.picUrl);
      formData.remark = res.remark;
      formData.carDisplacementList = res.carDischargeList.map(({
        dischargeId: carDisplacementId,
        discharge: carDisplacementName
      }) => {
        return {
          carDisplacementId,
          carDisplacementName
        };
      });
      formData.carLengthList = res.carLengthList;
      formData.carModelList = res.carModelList.map(({
        carModelId: vehicleTypeId,
        carModelName: vehicleTypeName
      }) => {
        return {
          vehicleTypeId,
          vehicleTypeName
        };
      });

      //再发一单
      if (route.query.again == 1) {
        formData.beginTime = "";
        formData.endTime = "";
        data.times = [];
      }
    };

    //查询发票抬头
    const queryInvoiceTitle = async () => {
      const res = await globalProperties.$api.queryInvoiceTitle();
      if (res) {
        data.invoiceTitleList = [res];
        formData.invoiceId = data.invoiceTitleList[0].invoiceId;
      }
    };

    //搜索货物名称
    const selectGoodsByGoodsName = async (goodsName = "") => {
      data.goods = await globalProperties.$api.queryGoodsName(goodsName);
    };
    const setSpecialFormData = (key, name, key2) => {
      if (formData[key].length > 3 && name != "不限") {
        formData[key].pop();
        return ElMessage({
          message: "最多选3项",
          type: "warning"
        });
      }
      if (name == "不限") {
        formData[key] = formData[key].filter(item => item[key2] == "不限");
        return;
      }
      if (formData[key].some(item => item[key2] == "不限")) {
        const targetIndex = formData[key].findIndex(item => item[key2] == "不限");
        formData[key].splice(targetIndex, 1);
        return;
      }
    };
    const queryPackageTypeName = async () => data.packageList = await globalProperties.$api.queryPackageTypeName();
    const selectTemperature = async () => data.temperatureList = await globalProperties.$api.queryTemperatureName();
    const getSelectCarLength = async () => data.carLen = await globalProperties.$api.queryCarLengthName();
    const getSelectCar = async () => data.carType = await globalProperties.$api.queryCarTypeName();
    const getSelectNewDischarge = async () => data.carDischarge = await globalProperties.$api.queryCarDisplacement();
    const setFormData = (key, goodsId) => {
      if (key == "goodsName") {
        const targetGood = data.goods.filter(item => item.goodsName == goodsId)[0];
        data.goodsId = targetGood.goodsId;
        data.targetGoodIsInsurance = targetGood.isInsurance;
      }
      formData[key] = goodsId;
    };
    const submitForm = async formEl => {
      if (!formEl) return;
      await formEl.validate(valid => {
        if (valid) {
          AMapLoader.load({
            key: "dbf41f7626575035500077916f66b1e3",
            version: "2.0",
            plugins: ["GeometryUtil"]
          }).then(async AMap => {
            var distance = await AMap.GeometryUtil.distance([formData.loading[0].lon, formData.loading[0].lat], [formData.unloading[0].lon, formData.unloading[0].lat]);
            distance = Math.ceil(distance / 1000);
            let params = {
              hasInvoice: formData.hasInvoice,
              addressList: [...formData.loading, ...formData.unloading],
              amount: formData.amount * 100,
              beginTime: formData.beginTime,
              carDisplacementList: formData.carDisplacementList.map(item => item.carDisplacementName),
              carLengthList: formData.carLengthList.map(item => item.carLengthName),
              carModelList: formData.carModelList.map(item => item.vehicleTypeName),
              carNum: formData.carNum,
              distance,
              endTime: formData.endTime,
              packageName: formData.packageName,
              remark: formData.remark,
              square: formData.square * 100,
              temperatureName: formData.temperatureName,
              tonnage: formData.tonnage * 100,
              unitType: formData.unitType,
              goodsPicUrlList: formData.goodsPicUrlList,
              loadingTime: `${moment(formData.beginTime).format("YYYY-MM-DD")}-${moment(formData.endTime).format("YYYY-MM-DD")}`,
              goodsName: formData.goodsName
            };
            route.query.demandId && (params["demandId"] = route.query.demandId);
            formData.hasInvoice && (params["invoiceId"] = formData.invoiceId);
            let res = route.query.demandId && route.query.again != 1 ? await globalProperties.$api.updateDemand(params) : await globalProperties.$api.sendDemand(params);
            if (res) {
              data.resultVisible = true;
            }
          });
        }
      });
    };

    //处理总价
    const handleTotalPrice = () => {
      formData.unitPrice = formData.unitPrice.toString().replace(/[^\-\d.]/g, "") //只能输入   数字 小数点 -
      .replace(/(?!^)-/g, "") // 只能出现一次-
      .replace(/^0+(\d)/, "$1") //如果第一位是 0 就替换成后面的数字
      .replace(/^\./, "0.") //如果第一位是 . 就 替换成  0.
      .match(/^[\d\-]*(\.?\d{0,1})/g)[0] || "";
      if (!formData.unitPrice) {
        formData.freight = 0;
      } else if (formData.freightUnitType == 1) {
        formData.freight = formData.unitPrice;
      } else {
        const begin = formData.freightUnitType == 2 ? formData.beginWeight : formData.beginVolume;
        const end = formData.freightUnitType == 2 ? formData.endWeight : formData.endVolume;
        formData.freight = (begin > end ? begin : end) * formData.unitPrice;
      }
      data.rateFee = actualCost(formData.unitPrice, data.rate, data.serviceRate);
    };

    //新增地址
    const insertAddress = key => {
      if (!Object.keys(formData[key][0]).length) {
        return ElMessage({
          message: "请选择地址",
          type: "warning"
        });
      }
      formData[key].push({});
    };

    //打开地图选址
    const openMap = (addressType, sort) => {
      data.addressType = addressType;
      data.sort = sort;
      data.dialogVisible = true;
    };
    const getCurrentAddress = value => {
      formData[data.addressType == 1 ? "loading" : "unloading"][data.sort] = value;
      data.dialogVisible = false;
    };
    const toPage = () => {
      mainStore.setTabIndex("1");
      router.replace("/layout/shipments");
    };

    //设置装货时间
    const setTimes = value => {
      data.times = value;
      formData.beginTime = moment(value[0]).format("YYYY-MM-DD") + " 00:00:00";
      formData.endTime = moment(value[1]).format("YYYY-MM-DD") + " 23:59:59";
    };

    //根据填写的货重选择单位
    const visibleChange = () => {
      data.freightUnitTypeList[0].disabled = !formData.tonnage;
      data.freightUnitTypeList[1].disabled = !formData.square;
    };

    //上传货物图片
    const uploadPic = async file => {
      let param = new FormData();
      param.append("file", file.raw);
      var res = await globalProperties.$api.uploadDemandGoodsPic(param);
      formData.goodsPicUrlList.push(res);
    };

    //移除货物图片
    const removePic = index => formData.goodsPicUrlList.splice(index, 1);
    return {
      visibleChange,
      removePic,
      uploadPic,
      carNumMap,
      mainStore,
      data,
      formRef,
      rules,
      formData,
      settleTypeMap,
      zhCn,
      submitForm,
      invoiceTypeList,
      selectGoodsByGoodsName,
      setFormData,
      setSpecialFormData,
      getCurrentAddress,
      depositTypeMap,
      followCarList,
      followCarTypeList,
      freightTypeList,
      setTimes,
      handleTotalPrice,
      insertAddress,
      openMap,
      toPage
    };
  }
};